/* eslint react/no-unused-prop-types: "off" */
import React, { forwardRef } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SearchToggle = forwardRef(({ children, onClick, bsClass }, ref) => (
  <Button ref={ref} onClick={(e) => onClick(e)} className={`${bsClass} custom-button`}>
    <span className="filter-options">
      {children}
      <span className="caret caret-filter" />
    </span>
  </Button>
));

SearchToggle.propTypes = {
  ref: PropTypes.oneOf([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  children: PropTypes.node,
  onClick: PropTypes.func,
  bsClass: PropTypes.string,
};

export default SearchToggle;
